import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { AdminProjectsCollection } from './admin-projects.types';

export function adminProjectsBackend(): Backend<AdminProjectsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: `projects/0.1/projects`,
      params: {
        attachment_details: 'true',
        full_description: 'true',
        job_details: 'true',
        location_details: 'true',
        projects: ids,
        selected_bids: 'true',
        upgrade_details: 'true',
        blasted_details: 'true',
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
